import { render, staticRenderFns } from "./DPCOrganizations.vue?vue&type=template&id=fd0dd538&"
import script from "./DPCOrganizations.vue?vue&type=script&lang=js&"
export * from "./DPCOrganizations.vue?vue&type=script&lang=js&"
import style0 from "./DPCOrganizations.vue?vue&type=style&index=0&id=fd0dd538&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports